module.exports = __webpack_public_path__ + "static/img/home_photo.813a99f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_photo.png
// module id = b47K
// module chunks = 1